import React, { FC } from 'react';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import {
	DeviceType,
	Lightbox,
	AppView,
	ArmrestsByCover,
	Platform,
	RangeSettings,
} from 'sofa-reborn-react';
import BuildTip from '../components/BuildTip';
import { localeService } from '../services';

const BuildTipContainer: FC = () => {
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);
	const appView = useSelector<RootState, AppView>((state) => state.application.appView);
	const rangeSettings = useSelector<RootState, RangeSettings>(
		(state) => state.settings.rangeSettings as RangeSettings
	);
	const buildTipHasBeenShown = useSelector<RootState, boolean>(
		(state) => state.popOver.buildTipHasBeenShown
	);
	const hideBuildTip = useSelector<RootState, boolean>((state) => state.popOver.hideBuildTip);
	const armrests = useSelector<RootState, ArmrestsByCover | null>(
		(state) => state.armrest.armrests
	);
	const hasArmrestPicker = armrests ? true : false;

	function buildTipLeft() {
		/* Build-tip */
		const arrowWidth = 100;
		const selectorWidth = document.getElementById('selector')?.clientWidth || 0;
		const swiperWidth = selectorWidth - 10;
		const leftOfScene = document.getElementById('scene')?.getBoundingClientRect().left || 0;
		return window.innerWidth - (swiperWidth + leftOfScene) - arrowWidth + 'px';
	}

	function buildTipTop(hasArmrestPicker: boolean) {
		/* Build-tip */
		return platform === 'kiosk'
			? hasArmrestPicker
				? '310px'
				: '230px'
			: hasArmrestPicker
			? '240px'
			: '200px';
	}

	if (
		appView === 'build-view' &&
		currentLightbox === 'none' &&
		deviceType !== 'mobile' &&
		deviceType !== 'tablet' &&
		!buildTipHasBeenShown
	) {
		return (
			<BuildTip
				buildTipItem={{
					src: rangeSettings.thumbnailsSrc + '/arrow_moduleswiper_to_scene.png',
					alt: localeService.getTranslation('buildTip'),
					top: buildTipTop(hasArmrestPicker),
					left: buildTipLeft(),
				}}
				hideBuildTip={hideBuildTip}
			></BuildTip>
		);
	} else {
		return null;
	}
};

export default BuildTipContainer;
